module.exports = __webpack_public_path__ + "static/media/conexao2.e6e3cc8b.png";